import { apiEndPoints, apiMethods } from '../../../../../../utils/apiConstants'
import customAxios from '../../../../../../utils/customAxios'

export const fetchMyStuffThunk = async (body) => {
	try {
		const responseJson = await customAxios[apiMethods.post](apiEndPoints?.pointsListingUser, body)
		const data = responseJson.data
		return data
	} catch (error) {
		throw error
	}
}

export const fetcheGiftShoppingApiThunk = async (body) => {
	try {
		const responseJson = await customAxios[apiMethods.post](apiEndPoints?.eGiftShoppingListingUser, body)
		const data = responseJson.data
		return data
	} catch (error) {
		throw error
	}
}

export const fetchMyGiftApiThunk = async (body) => {
	try {
		const responseJson = await customAxios[apiMethods.post](apiEndPoints?.myGiftListingUser, body)
		const data = responseJson.data
		return data
	} catch (error) {
		throw error
	}
}

export const fetchGiftInVoiceThunk = async (id) => {
	try {
		const responseJson = await customAxios[apiMethods.get](apiEndPoints?.getGiftInvoice(id))
		const data = responseJson.data
		return data
	} catch (error) {
		throw error
	}
}
